interface Props {
    visible: boolean;
}

const BadgeVoiceMessageUnread = ({ visible }: Props) =>
    visible ? (
        <div className="bg-red absolute start-1 top-1 size-2 rounded-full" />
    ) : null;

export default BadgeVoiceMessageUnread;
